import { Component, Input } from '@angular/core';
import { ORTechnicalDataForm } from '@bo-client/shared/models/orderRequestWizard.model';

@Component({
  selector: 'app-technical-data-required-power-formpart',
  templateUrl: './technical-data-required-power-formpart.component.html',
  styleUrl: './technical-data-required-power-formpart.component.scss'
})
export class TechnicalDataRequiredPowerFormpartComponent {
  @Input() control: ORTechnicalDataForm['controls']['requiredPower'];
  @Input() powerUnit: string;
  @Input() requiredMarker: boolean = true;
}
